import { render, staticRenderFns } from "./shopee.vue?vue&type=template&id=15bee6e2&scoped=true"
import script from "./shopee.vue?vue&type=script&lang=js"
export * from "./shopee.vue?vue&type=script&lang=js"
import style0 from "./shopee.vue?vue&type=style&index=0&id=15bee6e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15bee6e2",
  null
  
)

export default component.exports